import { FC } from "react";
import { ShuttleModal } from "../shuttle-modal";
import { TableShuttles } from "./table-shuttles";

type Props = {};

export const ListShuttles: FC<Props> = () => {
  return (
    <div>
      <ShuttleModal />

      {/* Shuttle Table */}
      <TableShuttles />
      {/* </div> */}
    </div>
  );
};
